import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/socials',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: '/settings/social/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `/settings/socials/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/socials',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/socials/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `/settings/socials/${id}`,
      method: 'delete',
  })
}
